export const formatCoordinates = (
  coordinatesData: [string, string]
): string[] => {
  const coordinatesArray: string[] = [...coordinatesData];

  const firstCoordinate = coordinatesData[0];

  coordinatesArray.push(firstCoordinate);

  return coordinatesArray;
};

export const formatDate = (date: string): string => {
  const [month, year] = date.split('-');

  return `${year}-${month}`;
};

export const formatCurrencyToNumber = (value: string): number => {
  let result = 0;

  const numericValue = value.replace('R$', '').replaceAll('.', '');

  if (numericValue) {
    result = parseFloat(numericValue);
  }

  return result;
};
